import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DialogModule } from 'primeng/dialog';
import { ComponentsModule } from '../components/components.module';
import { LoginLayoutComponent } from './login/login-layout/login-layout.component';
import { GestaoPerfisLayoutComponent } from './recursos-humanos/gestao-perfis-layout/gestao-perfis-layout.component';
import { GestaoAcessoLayoutComponent } from './recursos-humanos/gestao-acesso-layout/gestao-acesso-layout.component';
import { CriarPerfilLayoutComponent } from './recursos-humanos/criar-perfil-layout/criar-perfil-layout.component';
import { CriarUsuarioLayoutComponent } from './recursos-humanos/criar-usuario-layout/criar-usuario-layout.component';
import { DashboardRhLayoutComponent } from './recursos-humanos/dashboard-rh-layout/dashboard-rh-layout.component';
import { FrenteTrabalhoLayoutComponent } from './recursos-humanos/frente-trabalho-layout/frente-trabalho-layout.component';
import { NovaSenhaComponent } from './nova-senha/nova-senha-layout/nova-senha-layout.component';
import { ApontamentoLayoutComponent } from './encarregado/apontamento/apontamento-layout/apontamento-layout.component';
import { PontoLayoutComponent } from './encarregado/ponto/ponto-layout/ponto-layout.component';
import { DashboardEncarregadoLayoutComponent } from './encarregado//dashboard-encarregado/dashboard-encarregado-layout/dashboard-encarregado-layout.component';
import { AdvertenciaLayoutComponent } from './recursos-humanos/advertencia-layout/advertencia-layout.component';
import { CadastrarEpiLayoutComponent } from './encarregado/epis/cadastrar-epi-layout/cadastrar-epi-layout.component';
import { TermosLayoutComponent } from './encarregado/ponto/termos-layout/termos-layout.component';
import { NotFoundLayoutComponent } from './not-found/not-found-layout/not-found-layout.component';
import { HorarioDivergenteLayoutComponent } from './encarregado/ponto/horario-divergente-layout/horario-divergente-layout.component';
import { SelecaoPessoaLayoutComponent } from './encarregado/ponto/selecao-reeducando-layout/selecao-reeducando-layout.component';
import { PlanejamentoLayoutComponent } from './planejamento/planejamento-layout/planejamento-layout.component';
import { DiarioObraLayoutComponent } from './planejamento/diario-obra-layout/diario-obra-layout.component';
import { ProjetosLayoutComponent } from './engenharia/projetos/projetos-layout/projetos-layout.component';
import { CadastrarProjetoLayoutComponent } from './engenharia/projetos/cadastrar-projeto-layout/cadastrar-projeto-layout.component';
import { ListagemEpiLayoutComponent } from './encarregado/epis/listagem-epi-layout/listagem-epi-layout.component';
import { HomeLayoutComponent } from './home/home-layout/home-layout.component';
import { DisciplinasLayoutComponent } from './engenharia/disciplinas/disciplinas-layout/disciplinas-layout.component';
import { CadastrarDisciplinaLayoutComponent } from './engenharia/disciplinas/cadastrar-disciplina-layout/cadastrar-disciplina-layout.component';
import { ExtracaoRelatorioLayoutComponent } from './encarregado/apontamento/modal-extracao-relatorio-layout/modal-extracao-relatorio-layout.component';
import { ValidarProjetoLayoutComponent } from './engenharia/validacao/validar-projeto-layout/validar-projeto-layout.component';
import { RevisaoLayoutComponent } from './engenharia/projetos/revisao-layout/revisao-layout.component';
import { ListagemFrenteTrabalhoLayoutComponent } from './recursos-humanos/listagem-frente-trabalho-layout/listagem-frente-trabalho-layout.component';
import { ListagemValidacaoLayoutComponent } from './engenharia/validacao/listagem-validacao-layout/listagem-validacao-layout.component';
import { AssociarEpiLayoutComponent } from './encarregado/epis/associar-epi-layout/associar-epi-layout.component';
import { AssociarFrenteTrabalhoLayoutComponent } from './recursos-humanos/associar-frente-trabalho-layout/associar-frente-trabalho-layout.component';
import { CadastrarPessoaLayoutComponent } from './recursos-humanos/cadastrar-pessoa-layout/cadastrar-pessoa-layout.component';
import { ListagemPessoasLayoutComponent } from './recursos-humanos/listagem-pessoas-layout/listagem-pessoas-layout.component';
import { CriarApontamentoLayoutComponent } from './encarregado/ajustes/criar-apontamento-layout/criar-apontamento-layout.component';
import { ListagemLicencasLayoutComponent } from './recursos-humanos/listagem-licencas-layout/listagem-licencas-layout.component';
import { RegistrarLicencaLayoutComponent } from './recursos-humanos/registrar-licenca-layout/registrar-licenca-layout.component';
import { AcrescimoLayoutComponent } from './recursos-humanos/acrescimo-layout/acrescimo-layout.component';
import { EditarAcrescimoLayoutComponent } from './recursos-humanos/editar-acrescimo-layout/editar-acrescimo-layout.component';
import { HorariosLayoutComponent } from './encarregado/apontamento/modal-horarios-layout/modal-horarios-layout.component';
import { LogApontamentosLayoutComponent } from './logs/log-apontamentos-layout/log-apontamentos-layout.component';
import { ListagemAjustesLayoutComponent } from './encarregado/ajustes/listagem-ajustes-layout/listagem-ajustes-layout.component';
import { ModalDocumentoLayoutComponent } from './recursos-humanos/modal-documento-layout/modal-documento-layout.component';
import { CadastrarFornecedorLayoutComponent } from './suprimentos/cadastrar-fornecedor-layout/cadastrar-fornecedor-layout.component';
import { PedidoMaterialLayoutComponent } from './suprimentos/pedido-material-layout/pedido-material-layout.component';
import { FornecedoresLayoutComponent } from './suprimentos/fornecedores-layout/fornecedores-layout.component';
import { PedidosLayoutComponent } from './suprimentos/pedidos-layout/pedidos-layout.component';
import { ModalTermosEpiLayoutComponent } from './encarregado/epis/modal-termos-epi-layout/modal-termos-epi-layout.component';
import { EmailSenhaComponent } from './email-senha/email-senha.component';
import { UploadListaLayoutComponent } from './encarregado/apontamento/modal-upload-lista-layout/modal-upload-lista-layout.component';
@NgModule({
  declarations: [
    LoginLayoutComponent,
    GestaoPerfisLayoutComponent,
    CriarPerfilLayoutComponent,
    GestaoAcessoLayoutComponent,
    CriarUsuarioLayoutComponent,
    DashboardRhLayoutComponent,
    FrenteTrabalhoLayoutComponent,
    NovaSenhaComponent,
    ApontamentoLayoutComponent,
    PontoLayoutComponent,
    DashboardEncarregadoLayoutComponent,
    AdvertenciaLayoutComponent,
    CadastrarEpiLayoutComponent,
    PedidosLayoutComponent,
    CadastrarFornecedorLayoutComponent,
    TermosLayoutComponent,
    NotFoundLayoutComponent,
    HorarioDivergenteLayoutComponent,
    SelecaoPessoaLayoutComponent,
    PedidoMaterialLayoutComponent,
    PlanejamentoLayoutComponent,
    DiarioObraLayoutComponent,
    ListagemValidacaoLayoutComponent,
    ProjetosLayoutComponent,
    CadastrarProjetoLayoutComponent,
    ListagemEpiLayoutComponent,
    HomeLayoutComponent,
    DisciplinasLayoutComponent,
    CadastrarDisciplinaLayoutComponent,
    ExtracaoRelatorioLayoutComponent,
    UploadListaLayoutComponent,
    ValidarProjetoLayoutComponent,
    RevisaoLayoutComponent,
    ListagemFrenteTrabalhoLayoutComponent,
    AssociarEpiLayoutComponent,
    AssociarFrenteTrabalhoLayoutComponent,
    CadastrarPessoaLayoutComponent,
    ListagemPessoasLayoutComponent,
    CriarApontamentoLayoutComponent,
    ListagemLicencasLayoutComponent,
    RegistrarLicencaLayoutComponent,
    AcrescimoLayoutComponent,
    EditarAcrescimoLayoutComponent,
    HorariosLayoutComponent,
    LogApontamentosLayoutComponent,
    ListagemAjustesLayoutComponent,
    FornecedoresLayoutComponent,
    ModalDocumentoLayoutComponent,
    ModalTermosEpiLayoutComponent,
    EmailSenhaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskDirective,
    ComponentsModule,
    PdfViewerModule,
    DialogModule,
  ],
  exports: [
    LoginLayoutComponent,
    GestaoPerfisLayoutComponent,
    CriarPerfilLayoutComponent,
    GestaoAcessoLayoutComponent,
    CriarUsuarioLayoutComponent,
    DashboardRhLayoutComponent,
    FrenteTrabalhoLayoutComponent,
    NovaSenhaComponent,
    ApontamentoLayoutComponent,
    PontoLayoutComponent,
    DashboardEncarregadoLayoutComponent,
    AdvertenciaLayoutComponent,
    CadastrarEpiLayoutComponent,
    PedidosLayoutComponent,
    CadastrarFornecedorLayoutComponent,
    TermosLayoutComponent,
    NotFoundLayoutComponent,
    HorarioDivergenteLayoutComponent,
    SelecaoPessoaLayoutComponent,
    PedidoMaterialLayoutComponent,
    PlanejamentoLayoutComponent,
    DiarioObraLayoutComponent,
    ListagemValidacaoLayoutComponent,
    ProjetosLayoutComponent,
    CadastrarProjetoLayoutComponent,
    ListagemEpiLayoutComponent,
    HomeLayoutComponent,
    DisciplinasLayoutComponent,
    CadastrarDisciplinaLayoutComponent,
    ExtracaoRelatorioLayoutComponent,
    UploadListaLayoutComponent,
    ValidarProjetoLayoutComponent,
    RevisaoLayoutComponent,
    ListagemFrenteTrabalhoLayoutComponent,
    AssociarEpiLayoutComponent,
    AssociarFrenteTrabalhoLayoutComponent,
    CadastrarPessoaLayoutComponent,
    ListagemPessoasLayoutComponent,
    CriarApontamentoLayoutComponent,
    ListagemLicencasLayoutComponent,
    RegistrarLicencaLayoutComponent,
    AcrescimoLayoutComponent,
    EditarAcrescimoLayoutComponent,
    HorariosLayoutComponent,
    LogApontamentosLayoutComponent,
    ListagemAjustesLayoutComponent,
    FornecedoresLayoutComponent,
    ModalDocumentoLayoutComponent,
    ModalTermosEpiLayoutComponent,
    EmailSenhaComponent
  ],
  providers: [provideEnvironmentNgxMask({ validation: false })],
})
export class LayoutModule {}
